<ziro-fieldset-header [legend]="'tkey;pages.details.phoneSettings.mobility_identity'">
  <ziro-checkbox [fieldId]="'formSwitch'"></ziro-checkbox>
  <ziro-text [fieldId]="'name'"></ziro-text>
  <ziro-text [fieldId]="'destination'"></ziro-text>
  <ziro-text [fieldId]="'delayBeforeRingingInSeconds'"></ziro-text>
  <ziro-text [fieldId]="'answerTooSoonTimerInSeconds'"></ziro-text>
  <ziro-text [fieldId]="'answerTooLateTimerInSeconds'"></ziro-text>
</ziro-fieldset-header>
